import { render, staticRenderFns } from "./BoardingClassClassReportFilter.vue?vue&type=template&id=2624a95e&scoped=true&"
import script from "./BoardingClassClassReportFilter.vue?vue&type=script&lang=js&"
export * from "./BoardingClassClassReportFilter.vue?vue&type=script&lang=js&"
import style0 from "./BoardingClassClassReportFilter.vue?vue&type=style&index=0&id=2624a95e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2624a95e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VRow,VSelect})
